import { Link } from 'react-router-dom'
import { SNEAK_PEEK_VIDEO_URL } from '../lib/sneakPeek'

export default function SneakPeekPage() {
  return (
    <main className="sneak-peek-page" data-surface="working">
      <section className="sneak-peek-page-panel" aria-labelledby="sneak-peek-page-title">
        <div className="sneak-peek-header">
          <div>
            <span className="legal-eyebrow">Yan-Vada preview</span>
            <h1 id="sneak-peek-page-title">Season 01 Sneak-Peek</h1>
          </div>
          <Link to="/" className="sneak-peek-close" aria-label="Back to main pitch">×</Link>
        </div>
        <div className="sneak-peek-frame">
          <video
            src={SNEAK_PEEK_VIDEO_URL}
            poster="/sunset-1.jpeg"
            controls
            autoPlay
            playsInline
            preload="metadata"
          />
        </div>
      </section>
    </main>
  )
}

